<template>
  <div class="ma-2 ml-3 site_content">
    <comboFarm
        @fromFarm="farmInfo"
    />

    <div class="info_container mt-3">
      <div class="set_container mr-2">
        <div class="title">
          <div class="title_icon">
            🏠
          </div>
          <div class="title_text"> 돈사 환경 설정 </div>
        </div>

        <div class="setting_container farm_setting">
          <div v-if="room_type.length < 1">
            해당 서비스를 이용하실 수 없습니다.
          </div>

          <!-- 돈사 구분이 있는 경우에만 (현재 양돈만 해당)-->
          <div v-else>
            <div v-for="(room, r) in room_type" :key="r" class="input-section">
              <div class="room-title">{{ room.type.description }} </div>
              <div class="room-info mr-4">{{ room.rooms.length }}</div>

              <v-text-field dense outlined class="shrink" style="height: 45px; width: 100px; margin-right:10px !important;"
                id="room_temp" 
                ref="room_temp" 
                label="온도✽" 
                v-model="room.room_temp"
                suffix="℃"
              />

              <v-text-field dense outlined class="shrink" style="height: 45px; width: 100px;"
                id="room_hum" 
                ref="room_hum" 
                label="습도✽" 
                v-model="room.room_hum"
                suffix="%"
              />
            </div>
          </div>
          
        </div>

        <v-row justify="center"  v-show="room_type.length > 0">
          <v-btn class="calcul-btn" @click="calculator()" style="color:white !important;">
            ⚡️ 전력소비량 예측하기
          </v-btn>
        </v-row>
      </div>

      <div class="weather_container">
        <div class="title">
          <div class="title_icon">
            🌤️
          </div>
          <div class="title_text"> 48시간 기상예보 </div>
        </div>

        <div class="setting_container weather_info">
          <table class="weather-table">
            <tbody class="table_tbody">
              <tr>
                <th class="date_td">시간</th>
                <td class="date_td" v-for="item in weather_forecast" :key="item.date">{{ item.date.substring(10,16) }}</td>
              </tr>
              <tr>
                <th>온도</th>
                <td v-for="item in weather_forecast" :key="item.date">{{ item.temp }} °C</td>
              </tr>
              <tr>
                <th>습도</th>
                <td v-for="item in weather_forecast" :key="item.date">{{ item.hum }} %</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="forecast_container">
      <div class="title">
        <div class="title_icon">
          📊
        </div>
        <div class="title_text"> 전력소비량 예측 결과 </div>
      </div>

      <div class="result_section result_flex" v-if="watt_loading">
        <div class="spinner"></div>
      </div>

      <div class="result_section" v-else>
        <div class="result_value elect">
          <div>📊 이번달 일평균 전력량</div>
  
          <div class="watt_spinner" v-if="avg_loading">
            <div class="thin-spinner"></div>
          </div>
          <div class="result-value" v-else>{{ avg_watt }} </div>
          <div class="result-unit">kWh</div>
        </div>

        <div class="result_value today-forcast">
          <div>⚡️ 금일 전력 예측값</div>
          <div class="result-value" v-if="today_watt">{{today_watt.toFixed(2)}} </div>
          <div class="result-value" v-else> - </div>
          <div class="result-unit"> kWh</div>
        </div>

        <div class="result_value next-forcast">
          <div>⚡️ 명일 전력 예측값</div>
          <div class="result-value"  v-if="tomorrow_watt">{{tomorrow_watt.toFixed(2)}} </div>
          <div class="result-value" v-else> - </div>
          <div class="result-unit">kWh</div>
        </div>

        <div class="result_value esg-forcast">
          <div>🌱 온실가스 배출량</div>
          <div class="result-value" v-if="esg_value"> {{ esg_value.toFixed(2)}} </div>
          <div class="result-value" v-else> - </div>
          <div class="result-unit">tCO₂eq</div>
        </div>

        <div class="result_value money-forcast">
          <div>💰 예상 청구 금액</div>
          <div class="kepco-info">정기검침일 : {{ kepco_info.sday }} 일</div>
          <div class="result-value" style="margin-top:-3px;"> 
            {{ addCommas(Math.floor(predict_charge))}}
            <span class="result-unit"> 원</span>
          </div>
          <div class="result-unit">총 {{ addCommas(Math.floor(total_charge)) }} 원</div>
        </div>

      </div>
    </div>
    
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
// import Common from "@/utils/custom/common.js";

import comboFarm from "@/components/combo/farm.vue";


export default ({
  name:"ElectAi",
  components:{
    comboFarm
  },
  watch:{
    farmData: {
      handler() {
        this.refresh();
      },
      deep: true // farmData 내부의 객체 속성 변화도 감지
    },
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
    
    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.getFullYear(), cdate.getMonth(), 1);
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

  },
  data(){
    return{
      farmData: { company: {}, farm: {} },
      
      loading:false,

      room_type:[],
      weather_forecast:[],
      
      headers:[
        { text: '시간', value: 'date'},
        { text: '온도', value: 'temp' },
        { text: '습도', value: 'hum' },
      ],

      room_temp:'',
      room_hum:'',

      kepco_info:{},
      now_charge:'',
      predict_charge:'',
      total_charge:'',
  
      predict_watt:[ ],
      today_watt:'',
      tomorrow_watt:'',
      total_watt:'',
      esg_value:'',

      watt_loading:false,

      to_date:'',
      fr_date:'',
      watt_daily:[],
      avg_watt:'',

      avg_loading:false,



    }
  },
  methods:{
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refresh();
    },

    refresh(){
      this.loading = true;

      Apis.getDivisionsOfRoomsInFarm({
        farm_cd:this.farmData.farm.code
      },(res) => {  // 정상처리
      // console.log(res);

      this.weather_forecast = res.data.weather.forehourly;

      const exclude = ['', 'RT98']; // 제외할 룸 타입들 (룸타입이 없거나 기타 제외)

      this.room_type = res.data.types.filter(item => 
        !exclude.includes(item.type.code) 
      );

      this.loading = false;

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("getDivisionsOfRoomsInFarm 호출 오류",err);
      });
    },

    calculator(){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }

      this.watt_loading = true;

      const forecast = [];
      
      this.room_type.forEach((room) => {
        if (!room.room_temp || !room.room_hum) {
          return;
        }
        
        // 방 개수만큼 온도/습도 데이터 추가
        for (let i = 0; i < room.rooms.length; i++) {
          forecast.push({
            room_cd : room.rooms[i].room.code,
            room_name : room.rooms[i].room.name,
            temp: parseFloat(room.room_temp),
            hum: parseFloat(room.room_hum)
          });
        }
      });

      Apis.predictWatt({
        farm_cd:this.farmData.farm.code,
        room_info_list:forecast
      },(res) => {  // 정상처리
        // console.log(res);
        this.predict_watt = res.data.timely;
        this.predict_charge = res.data.amount;

        // console.log(this.predict_charge)
        
        const half = Math.floor(res.data.timely.length / 2);

         //금일 전력 예측값
        this.today_watt = this.predict_watt
          .slice(0, half)
          .reduce((sum, item) => sum + item.predicted_watt, 0);
        

        //명일 전력 예측값
        this.tomorrow_watt = this.predict_watt
          .slice(half)
          .reduce((sum, item) => sum + item.predicted_watt, 0);

        //전력 예측값 합산
        this.total_watt = this.today_watt + this.tomorrow_watt;

        //온실가스 배출량
        this.esg_value = this.total_watt * 0.0004781

        this.kepcoDataDailyViewEach();
        this.listAmountForEnergyPerMonth();

        this.watt_loading = false;
      
      }).catch( (err) => { 
        console.log("predictWatt 호출 오류",err);
      });

    },

    // 정기검침일, 현재 예상 금액
    listAmountForEnergyPerMonth(){
      Apis.estimateAmountForEnergyPerMonth({
        kepcoNo: this.farmData.farm.kepco,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
      }, (res) => {
        this.kepco_info = res.data[0];
        this.now_charge = res.data[0].est_charge_fee

        this.total_charge = this.now_charge + this.predict_charge
        // console.log(res.data)
      }).catch((err) => {
        console.log("listAmountForEnergyPerMonth API 호출 오류", err);
        this.tableloading = false;
      });
    },
    // 일평균 전력량
    kepcoDataDailyViewEach(){
      this.avg_loading = true;
      Apis.kepcoDataDailyViewEach({ 
        farm_cd : this.farmData.farm.code,
        fr_date : this.fr_date,
        to_date : this.to_date
      },(res) => {  
        // console.log(res)
        this.watt_daily = res.data[0].daily;

      
        if (Array.isArray(this.watt_daily) && this.watt_daily.length > 0) {
          const TotaldailyWatt = this.watt_daily.reduce((sum, item) => {
            return sum + parseFloat(item.watt_sum);
          }, 0);

          const averageWatt = (TotaldailyWatt / this.watt_daily.length).toFixed(2);
          this.avg_watt = averageWatt;
        } else {
          this.avg_watt = '0.00';
        }

        this.avg_loading = false;


      }).catch( (err) => {  // API 오류 처리
        console.log("kepcoDataDailyViewEach API 호출 오류",err)
        alert(err);
        this.loading = false;
      })
    },
    checkData(){
      for (let i in this.room_type) {
        if (!this.room_type[i].room_temp) {
          this.$refs.room_temp[i].focus();
          return "온도 값을 설정해주세요.";
        }
        
        if (!this.room_type[i].room_hum) {
          this.$refs.room_hum[i].focus();
          return "습도 값을 설정해주세요.";
        }


        if (this.room_type[i].room_temp < 0 || this.room_type[i].room_temp > 46) {
          this.$refs.room_temp[i].focus();
          return "온도는 0℃이상 또는 45℃ 이하 값을 설정해주세요.";
        }


        if (this.room_type[i].room_hum < 0 || this.room_type[i].room_hum > 101) {
          this.$refs.room_hum[i].focus();
          return "습도는 0%이상 또는 100% 이하 값을 설정해주세요.";
        }
      }
    },
    addCommas(num){
      if (typeof num === 'number') {
          return num.toLocaleString();
      }
      return num;
    },
    
  }
})
</script>

<style scoped lang=scss>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';
.site_content{
  width:1150px !important;
}
.flex{
  display: flex;
}
::v-deep .selectmid{
  width:160px;
  height:45px;
}

.v-select , v-combobox{
  max-width:240px;
  margin-right:5px !important;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height:40px;
}
.normal-btn{
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  min-width: unset !important;
  background-color:#E3F2FD !important;
  margin-left:5px;
}
.info_container{
  width:100%;
  display: flex;
}
.set_container, .weather_container{
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding:20px;
}
.set_container{
  width:37%;
}
.weather_container{
  width:63%;
}
.title{
  display: flex;
  align-items: center;
}
.title_icon{
  background: #FFFFFF;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding:5px;
  margin-right:10px;
  width:35px;
  height:35px;
}
.title_text{
  font-size:1.1rem;
  font-weight: 550;
  letter-spacing: -1px;
}
.setting_container{
  height:33vh;
  padding:5px;
  overflow-x: scroll; /* 가로 스크롤 항상 표시 */
  overflow-y: auto;   /* 세로는 필요시만 */

  display: flex;
  align-items: center;
}
.farm_setting{
  margin-top:10px;
  margin-left:7px;
}
.setting_container::-webkit-scrollbar {
  width:8px;
  height: 8px; /* 가로 스크롤바 높이 */
}

.setting_container::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 4px;
}

.setting_container::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  border-radius: 4px;
}

.setting_container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.forecast_container{
  margin-top:10px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding:20px;
}
.weather-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.weather-table th {
  background-color: #f5f5f5;
  font-weight: 600;
  text-align: center;
  padding: 10px;
  border: 1px solid #e0e0e0;
  width: 70px; /* 고정 넓이 */
  min-width: 70px;
}
.weather-table .date_td{
  background-color: #4A5568;
  color:white;
}

.weather-table td {
  text-align: center;
  padding: 12px 8px;
  border: 1px solid #efefef;
  width: 90px;
  min-width: 90px;
  white-space: nowrap;
}

.weather-table tr:nth-child(even) {
  background-color: #fafafa;
}

.calcul-btn{
  width: 170px !important;
  height: 41px !important;

  background: #2D3748 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
  color:white !important;
  padding:5px 20px 10px !important;
  font-weight:600;
  letter-spacing: -0.75px;

  margin-bottom: 5px;
}
.input-section{
  width:100%;
  padding:5px 10px;
  margin:5px 0;
  display: flex;
  align-items: center;

  background: #F5F7FA;
  border: 1px solid #EEEEEE;
  border-radius: 10px;

}
.input-section .room-title{
  font-size:1.1rem;
  font-weight: 550;
  letter-spacing: -1px;
  width:60px;
}
.input-section .room-info{
  // padding:0px;
  font-size:0.8rem; 
  width:33px;
  text-align: center;
  background: #D9D9D9;
  border-radius: 5px;
  margin: 0 5px;
}
.result_section{
  height:13.5vh;
  margin-top:20px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.result_value{
  padding:10px;
  border-radius: 15px;
  background-color: #e5e5e5;
  text-align: center;
}
.result_value div{
  font-weight:550;
  letter-spacing: -1px;
}
.result-value{
  letter-spacing: -2px !important;
  margin-top:15px;
  font-weight: 600;
  font-size:1.7rem;
}
.result-unit{
  font-weight: 620;
  font-size:1.0rem;
}
.elect{
  background: #F8FAFB;
  border: 1px solid #D1D5DB;
}
.today-forcast{
  background: #EFF4FF;
  border: 1px solid #C8E1FE;
}
.next-forcast{
  background: #F7F3FF;
  border: 1px solid #E9D5FF;
}
.esg-forcast{
  background: #EFFDF4;
  border: 1px solid #BBF7D0;
}
.money-forcast{
  background: #FFF8EC;
  border: 1px solid #FDE997;
}
.kepco-info{
  font-weight:550;
  font-size:0.85rem;
  text-align: right;
  color:#7f7f7f;
}
.result_flex{
  display: flex;
  justify-content: center;
}
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #4A5568;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: auto;
}
.result-value{
  height: 35px;
}
.watt_spinner{
  margin-top:20px;
  // height:px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>